/* eslint-disable import/prefer-default-export */
import gql from 'graphql-tag';

export const getNotices = (client, variables, fetchPolicy = 'no-cache') => client
    .query({
      query: gql`
        query GetGolfNotices($id: String!) {
          golfNotices(id: $id) {
            context
            content
            lang
          }
        }
      `,
      fetchPolicy,
      variables,
    })
    .then(({ data }) => data.golfNotices);
